import RichText from '@eneco/components/RichText/RichText';
import { ReferToAccountNumberIfRefundCardResponse } from '@eneco/dc-be/client';
import { useFormatter } from '@eneco/i18n';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';

export const ReferToAccountNumberIfRefundCard = ({ card }: { card: ReferToAccountNumberIfRefundCardResponse }) => {
  const { fields } = useContent<DashboardOverviewRendering>();
  const { format, currency } = useFormatter();
  const { summary } = card.details;
  const { records } = summary;
  const totalRefundAmount = Math.abs(records.reduce((acc, record) => acc + record.amount, 0));
  const bankAccountNumber = records[0].iban;
  return (
    <StyledDashboardBlock>
      {bankAccountNumber ? (
        <RichText
          html={format(fields.referToAccountNumberIfRefundCard.withIbanDescription.value, {
            totalRefundAmount: currency.euro(totalRefundAmount),
            bankAccountNumber,
          })}
        />
      ) : (
        <RichText
          html={format(fields.referToAccountNumberIfRefundCard.withoutIbanDescription.value, {
            totalRefundAmount: currency.euro(totalRefundAmount),
          })}
        />
      )}
      {bankAccountNumber ? (
        <DashboardLink
          href={fields.referToAccountNumberIfRefundCard.invoicesLink.value.href}
          emphasis="high"
          trackingComponentName="refer_to_account_refund_invoices_link"
          trackingComponentType="dashboard_link">
          {fields.referToAccountNumberIfRefundCard.invoicesLink.value.text}
        </DashboardLink>
      ) : (
        <DashboardLink
          href={fields.referToAccountNumberIfRefundCard.payLink.value.href}
          emphasis="high"
          trackingComponentName="refer_to_account_refund_pay_link"
          trackingComponentType="dashboard_link">
          {fields.referToAccountNumberIfRefundCard.payLink.value.text}
        </DashboardLink>
      )}
    </StyledDashboardBlock>
  );
};
